import React, { useState } from 'react';
import ListAreas from './ListAreas.js';
import AddArea from './AddArea.js';
import Upload from '../../shared/Upload.js';
import { ListButton, AddButton, UploadButton, DownloadButton, FAB } from '../../shared/ActionButtons';

export const Areas = ({ screen, setScreen, hideHeader }) => {
  const [localScreen, setLocalScreen] = useState("list");

  // Use passed screen/setScreen if provided, otherwise use local state
  const currentScreen = screen !== undefined ? screen : localScreen;
  const setCurrentScreen = setScreen || setLocalScreen;

  return (
    <>
      {!hideHeader && (
        <div className="content-header">
          <div className="action-buttons">
            <ListButton
              isActive={currentScreen === "list"}
              onClick={() => setCurrentScreen("list")}
            />
            <AddButton
              isActive={currentScreen === "add"}
              onClick={() => setCurrentScreen("add")}
            />
            <UploadButton
              isActive={currentScreen === "upload"}
              onClick={() => setCurrentScreen("upload")}
            />
            <DownloadButton collection="areas"/>
          </div>
        </div>
      )}

      {(currentScreen === "list") && <ListAreas/>}
      {(currentScreen === "list") && <FAB onClick={() => setCurrentScreen("add")} />}
      {(currentScreen === "add") &&
        <AddArea
          onSuccess={() => setCurrentScreen("list")}
        />
      }
      {(currentScreen === "upload") &&
        <Upload collection="areas"
          onSuccess={() => setCurrentScreen("list")}
        />
      }
    </>
  );
}

// Action buttons component for use in hub header
export const AreasActions = ({ screen, setScreen }) => (
  <div className="action-buttons">
    <ListButton
      isActive={screen === "list"}
      onClick={() => setScreen("list")}
    />
    <AddButton
      isActive={screen === "add"}
      onClick={() => setScreen("add")}
    />
    <UploadButton
      isActive={screen === "upload"}
      onClick={() => setScreen("upload")}
    />
    <DownloadButton collection="areas"/>
  </div>
);

export default Areas;
